export const CHECKOUT_URL = 'https://mister-pro.impultienda.ar/';
